<template>
  <base-container class="cube-radio-modal-page">
    <radio-modal-default class="demo-item" />
    <radio-modal-option-conf class="demo-item" />
    <radio-modal-cancel-btn class="demo-item" />
    <radio-modal-slots class="demo-item" />
  </base-container>
</template>

<script>
import { createPage } from '@mpxjs/core'

createPage({})
</script>

<style lang="stylus">
.cube-radio-modal-page
  .demo-item:not(:last-child)
    display block
    margin-bottom: 10px
</style>

<script type="application/json">
  {
    "usingComponents": {
      "base-container": "../../components/base-container/index",
      "view-desc": "../../components/desc/index",
      "radio-modal-default": "./radio-modal-default.mpx",
      "radio-modal-option-conf": "./radio-modal-option-conf.mpx",
      "radio-modal-cancel-btn": "./radio-modal-cancel-btn.mpx",
      "radio-modal-slots": "./radio-modal-slots.mpx"
    }
  }
</script>
